export enum KEY_CODE {
  ESCAPE = 'Escape'
}
